import { render, staticRenderFns } from "./OrderHistoryModal.vue?vue&type=template&id=6b5f90ae&scoped=true&"
import script from "./OrderHistoryModal.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryModal.vue?vue&type=style&index=0&id=6b5f90ae&prod&scoped=true&lang=scss&"
import style1 from "./OrderHistoryModal.vue?vue&type=style&index=1&id=6b5f90ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f90ae",
  null
  
)

export default component.exports